import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectLongDataFilteredComponent } from './select-long-data-filtered.component';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { TooltipModule } from '@web-frontend/shared/directives/tooltip/tooltip.module';



@NgModule({
  declarations: [
    SelectLongDataFilteredComponent
  ],
  imports: [
    CommonModule, FormsModule, TranslateModule.forChild(), NgSelectModule, TooltipModule
  ],
  exports: [SelectLongDataFilteredComponent]
})
export class SelectLongDataFilteredModule { }
